<template>

  <div class="bg-white overflow-hidden shadow-sm p-3 sm:rounded-xs border my-3">

    <!-- devex progress bar test start -->
    <div class="flex justify-between">
     <div>
      <h2 class="font-semibold text-lg text-gray-800 leading-tight">Attendance Summary</h2>
      <p class="text-xs">Total Days - {{ totalDays }}</p>
     </div>

    <div class="">
      <div class="max-w-xs mx-auto">
         
          <div class="relative">
              <select id="options"  v-model="selectedPeriod" class="block text-xs appearance-none mr-2 w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2  rounded leading-tight focus:outline-none focus:shadow-outline">
                  <option value="currentMonth">Current Month</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="currentYear">Current Year</option>
                  <option value="lastSixMonth">Last 6 Month</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 12l-5-5h10l-5 5z"/></svg>
              </div>
          </div>
      </div>
    </div>

     </div>
     

    <DxChart id="chart" :data-source="filteredDataSource" 
    :rotated="true" :size="{ height: 120 }">

    <DxSize
          :height="giHeight"
          :width="giWidth"
        />
      <DxArgumentAxis 
      :label="{ visible: false }"
      :visible="false"
      :tick="{ visible: false }"
      :grid="{ visible: false }">
      </DxArgumentAxis>

      <DxValueAxis 
      :label="{ visible: false }"
      :visible="false"
      :tick="{ visible: false }"
      :grid="{ visible: false }"> 
      </DxValueAxis>

      <DxCommonSeriesSettings argument-field="period" type="fullstackedbar" :bar-padding="0.8"/>
      <!-- <DxTitle horizontal-alignment="left" text="Attendance Summary" subtitle="Total Days"   /> -->

      <DxSeries v-for="(series, index) in seriesData" :key="index" :value-field="series.valueField" :name="series.name" :color="series.color" />
      
      <DxLegend vertical-alignment="bottom" horizontal-alignment="center" item-text-position="right" />
     
      <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
     
    </DxChart>
    <!-- devex progress bar test end -->
  </div>

</template>

<script>
import JetButton from '@/Jetstream/Button.vue'
import {
  DxArgumentAxis,
  DxLabel,
  DxGrid,
  DxTick,
  DxValueAxis,
  DxChart,
  DxSeries,
  DxCommonSeriesSettings,
  DxTitle,
  DxLegend,
  DxTooltip,
  DxAnnotations,
  DxAnnotation,
  DxSize
} from 'devextreme-vue/chart';

export default {
  props:{
    giHeight:Number,
    giWidth:Number,
   
  },
  components: {
    JetButton,
    DxArgumentAxis,
    DxLabel,
    DxGrid,
    DxTick,
    DxValueAxis,
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxTitle,
    DxLegend,
    DxAnnotations,
    DxAnnotation,
    DxTooltip,
    DxSize
  },

  data() {

    return {
      selectedPeriod: 'currentMonth',
      currentMonthDataSource: [{ period: 'Current Month', Present: 23, Leave: 2, WeekOff: 4 }],
      lastMonthDataSource: [{ period: 'Last Month', Present: 25, Leave: 1, WeekOff: 4 }],
      currentYearDataSource: [{ period: 'Current Year', Present: 169, Leave: 12, WeekOff: 30 }],
      lastSixMonthsDataSource: [{ period: 'Last 6 Months', Present: 150, Leave: 8, WeekOff: 24 }],

    };
  },

  methods: {
    customizeTooltip({ percentText, valueText }) {
      return { text: `${percentText}: ${valueText} days` };
    },
    getMonthName(monthIndex) {
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return monthNames[monthIndex];
    },
   
  },

  computed: {
    filteredDataSource() {
      switch (this.selectedPeriod) {
        case 'currentMonth':
          return this.currentMonthDataSource;
        case 'lastMonth':
          return this.lastMonthDataSource;
        case 'currentYear':
          return this.currentYearDataSource;
        case 'lastSixMonth':
          return this.lastSixMonthsDataSource;
        default:
          return [];
      }
    },
    totalDays() {
      const data = this.filteredDataSource[0] || { Present: 0, Leave: 0, WeekOff: 0 };
      return data.Present + data.Leave + data.WeekOff;
    },
    seriesData() {
      const data = this.filteredDataSource[0] || { Present: 0, Leave: 0, WeekOff: 0 };
      return [
        { valueField: 'Present', name: `Present- ${data.Present}`, color: '#10b981' },
        { valueField: 'Leave', name: `Leave - ${data.Leave}`, color:'#e55f5f' },
        { valueField: 'WeekOff', name: `Others - ${data.WeekOff}`, color: '#049fe5' },
      ];
    },

  }
}

</script>

<style >
p {
  margin-top: 0;
  margin-bottom: 0.1rem;
}

h2, h6 {
  margin-bottom: 0.1rem;
}

.dxc-title{
  text-align: left !important;
}

#chart {
  height: 118px !important;
}

</style>